<form *ngIf="applicantContantInfo"  [formGroup]="applicantContantInfo" class="editForm" novalidate>
  <h5>Contact Information</h5><br/>

  <div class="" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>
            Applicant's Phone No.
            <small class="text-muted">(required: For Text Messages)</small>
          </label>
          <input formControlName="PrimaryNumber" type="tel" class="form-control" placeholder="233200000000">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            Other Phone No. <small class="text-muted">(if any)</small>
          </label>
          <input formControlName="OtherNumber" type="tel" class="form-control" placeholder="233200000000">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Email Address (required)</label>
          <input formControlName="Email" type="email" class="form-control" placeholder="example@domain.com">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>
            Fax Number
             <!-- <small class="text-muted">(required)</small> -->
          </label>
          <input formControlName="FaxNumber" type="text"  autofocus class="form-control" placeholder="Fax Number">
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label>
            Contry Of Origin <small class="text-muted">(required)</small>
          </label>
          <select formControlName="CountryId" class="form-control">
            <option value="">Select Country</option>
            <option *ngFor="let item of countries" value="{{item.ValueId}}">
              {{item.DisplayValue}}
            </option>

          </select>
        </div>
      </div>



      <div class="col-md-6" *ngIf="!isForignStudent()">
        <div class="form-group">
          <label>
            Region <small class="text-muted">(required)</small>
          </label>
          <select formControlName="RegionId" class="form-control">
            <option value="">Select Region</option>
            <option *ngFor="let item of regions" value="{{item.ValueId}}">
              {{item.DisplayValue}}
            </option>

          </select> </div>
      </div>
    </div>


    <div class="row">




      <div class="col-md-6">
        <div class="form-group">
          <label *ngIf="!isForignStudent()">
            Home Town <small class="text-muted">(required)</small>
          </label>
          <label  *ngIf="isForignStudent()">
            State/Province <small class="text-muted">(required)</small>
          </label>
          <input formControlName="HomeTown" type="text"  autofocus class="form-control" placeholder="" >
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>
            City / Town <small class="text-muted">(required)</small>
          </label>
          <input formControlName="City" type="text"  autofocus class="form-control" placeholder="City or Town">
        </div>
      </div>

    </div>



    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>
            Postal Address <small class="text-muted">(required)</small>
          </label>
          <input formControlName="AddressLine1" type="text"  autofocus class="form-control" placeholder="">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>
            Residential Address <small class="text-muted">(required)</small>
          </label>
          <input formControlName="ResidentialAddress1" type="text"  autofocus class="form-control" placeholder="">
        </div>
      </div>
    </div>



    <div class="row">
      <div class="col-md-6" *ngIf="!isForignStudent()">
        <div class="form-group">
          <label>
            Ghana GPS Code <small class="text-muted">(if any)</small>
          </label>
          <input formControlName="GhanaPostCode" type="text"  autofocus class="form-control" placeholder="">
        </div>
      </div>

    </div>
    <!-- <h6>{{error}}</h6>
        <pre>{{ applicantContantInfo.value | json }}</pre>
        <h4>{{applicantContantInfo.valid}}</h4> -->
    <button class="btn btn-default waves-effect waves-light m-1 float-left" (click)="goToPrevious(applicantContantInfo)"><i
        class="fa fa-backward"></i> Go Back</button>
    <button class="btn btn-primary waves-effect waves-light m-1 float-right" id="next" [disabled]="!applicantContantInfo.valid"
      (click)="goToNext(applicantContantInfo)"> Save &amp; Continue </button>

  </div>



</form>
